/* Parts cards: fetch the cross sell, then stamp fitment on it.

   TWO JOBS, ONE FILE, because the second depends on the first. Shopify does
   not populate the recommendations object on a normal product page render, so
   the section comes back empty and has to be asked for again by URL. Anything
   that decorates those cards therefore has to run after that request lands,
   not on DOMContentLoaded.

   NOTHING IS CLAIMED WITHOUT DATA. No trailer on file, or no fitment recorded
   against the part, and no tag is drawn at all. A card that stays quiet is
   correct; a card that guesses is not.

   No requestAnimationFrame anywhere. document.hidden is true in an automation
   tab and rAF never fires there, which is how a previous script appeared to
   work for everybody except the one place we test from. */
(function () {
  'use strict';

  /* The section carries its own script tag so it still works when the grid
     arrives from a section render. A second copy on the page would run a
     second timer for the same cards. */
  if (window.fxCardsOn) return;
  window.fxCardsOn = 1;

  var TAGS = {
    definite: {
      cls: 'fx-pc__tag--definite',
      label: 'Fits',
      icon: '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8.6 L6.3 11.9 L13 5" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    },
    verify: {
      cls: 'fx-pc__tag--verify',
      label: 'Likely fits',
      icon: '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 4.2 v4.4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="8" cy="11.6" r="1.1" fill="currentColor"/></svg>'
    }
  };

  function norm(s) {
    return String(s == null ? '' : s).toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
  }

  function listOf(el, attr) {
    return String(el.getAttribute(attr) || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  /* What the customer owns. fx-trailer.js is the one place that answers this,
     and it loads site wide ahead of everything else, so a missing answer here
     means the file did not load, not that there is no trailer. Staying quiet
     is the right failure: a card with no tag is correct, a card guessing is
     not. */
  function trailer() {
    return window.fxTrailer ? window.fxTrailer() : null;
  }

  /* The same ladder the app block applies, from the same metafields, so a tag
     on a card and the verdict on the part's own page cannot disagree. */
  function verdict(card, t) {
    var models = listOf(card, 'data-models');
    if (!models.length) return null;          /* nothing recorded, say nothing */
    if (!t) return null;                      /* nobody to check it against */

    var modelOk = models.some(function (m) { return norm(m) === norm(t.model); });
    if (!modelOk) return 'no';

    /* No year list means the part is not year sensitive. A year we were never
       given is not a mismatch either, it is a thing we do not know. */
    var years = listOf(card, 'data-years');
    if (years.length && t.year && years.indexOf(t.year) === -1) return 'no';

    return String(card.getAttribute('data-confidence') || '').toLowerCase() === 'definite'
      ? 'definite'
      : 'verify';
  }

  function stamp() {
    var t = trailer();
    var cards = document.querySelectorAll('[data-fx-pc]');

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var want = verdict(card, t);
      var key = want || '';

      /* Compare before writing. Rewriting the same tag on every pass
         invalidates style and layout for nothing, and this runs on a timer. */
      if (card.getAttribute('data-fx-fit') === key) continue;
      card.setAttribute('data-fx-fit', key);

      var old = card.querySelector('.fx-pc__tag');
      if (old && old.parentNode) old.parentNode.removeChild(old);

      /* A part that does not fit still belongs in the grid, because the
         customer may be buying for a second trailer. It just does not get a
         green tick. */
      var spec = TAGS[want];
      if (!spec) continue;

      var shot = card.querySelector('[data-fx-pc-shot]');
      if (!shot) continue;

      var tag = document.createElement('span');
      tag.className = 'fx-pc__tag ' + spec.cls;
      tag.innerHTML = spec.icon + '<span>' + spec.label + '</span>';
      shot.appendChild(tag);
    }
  }

  /* ---- cropping only where cropping is safe ----------------------------
     The frames are 4:3. Most of the catalogue is shot 4:3, a lot of it is
     3:2, and a few are much wider than either. Cover is right for the first
     two, because the tenth it takes off a 3:2 shot is sweep, not part. It is
     wrong for a panorama, where it would cut a long part in half, so anything
     outside the band gets stamped and falls back to contain.

     The band is 1.15 to 1.55: a 3:2 photo at 1.500 is in, a 1000x430 part
     shot at 2.33 is out. Measured off naturalWidth, so it only decides once
     the photo has actually loaded.

     The attribute is data-fx-crop, not data-fx-fit. data-fx-fit already means
     the fitment verdict and lives on the card; this lives on the frame inside
     it, and two attributes a word apart on nested elements is how somebody
     ends up debugging the wrong one. */
  var LO = 1.15, HI = 1.55;

  function fitFrames() {
    var imgs = document.querySelectorAll('.fx-pc__shot img, .product-grid .card__media .media img, .vcp-more-host .diagram-thumb img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.naturalWidth || !img.naturalHeight) continue;

      var frame = img.closest('.fx-pc__shot, .card__media, .diagram-thumb');
      if (!frame) continue;

      var r = img.naturalWidth / img.naturalHeight;
      var want = (r >= LO && r <= HI) ? '' : 'contain';

      /* Compare before writing: this runs on the same timer as everything
         else and rewriting an unchanged attribute invalidates style. */
      if ((frame.getAttribute('data-fx-crop') || '') === want) continue;
      if (want) frame.setAttribute('data-fx-crop', want);
      else frame.removeAttribute('data-fx-crop');
    }
  }

  /* ---- asking for the section again -----------------------------------
     MANUAL FIRST, AUTOMATIC AS THE NET. When the section carries a fall
     through URL, the first request is the parts team's own complementary list
     and the second is Shopify's guess, tried only when the first came back
     with nothing. The heading and the source line are swapped at the same
     time, from attributes the section printed, because the second request
     renders the same Liquid and cannot tell which intent it was asked for.
     Labelling an algorithm's list as somebody's choice is the one outcome
     this whole arrangement exists to avoid. */
  function fetchInto(host, url, id, then) {
    fetch(url + '&section_id=' + id, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) { then(false); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-fx-recs]');
        if (!fresh || !fresh.querySelector('.fx-pc')) { then(false); return; }
        host.innerHTML = fresh.innerHTML;
        stamp();
        fitFrames();
        then(true);
      })
      .catch(function () { then(false); });
  }

  function pull(host) {
    if (host.getAttribute('data-fx-pulled')) return;
    host.setAttribute('data-fx-pulled', '1');

    var url = host.getAttribute('data-url');
    var id = host.getAttribute('data-section-id');
    if (!url || !id || !window.fetch) return;

    fetchInto(host, url, id, function (ok) {
      if (ok) return;

      var alt = host.getAttribute('data-url-alt');
      if (!alt) return;

      fetchInto(host, alt, id, function (ok2) {
        if (!ok2) return;
        var head = host.querySelector('[data-fx-head]');
        var note = host.querySelector('[data-fx-note]');
        var wantHead = host.getAttribute('data-head-alt');
        var wantNote = host.getAttribute('data-note-alt');
        if (head && wantHead) head.textContent = wantHead;
        if (note && wantNote) note.textContent = wantNote;
      });
    });
  }

  function start() {
    var hosts = document.querySelectorAll('[data-fx-recs]');
    for (var i = 0; i < hosts.length; i++) {
      if (!hosts[i].querySelector('.fx-pc')) pull(hosts[i]);
    }
    stamp();
    fitFrames();

    /* The trailer can change under the page: My Trailer is a site wide drawer
       and it does not know this script exists. A slow poll is cheaper than
       wiring an event through three scripts that have never met, and it is
       also how a frame gets measured once its photo has loaded. */
    setInterval(function () { stamp(); fitFrames(); }, 900);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else setTimeout(start, 0);
})();
